import set from "lodash/fp/set";
import get from "lodash/get";
import isArray from "lodash/isArray";
import isEmpty from "lodash/isEmpty";
import isEqual from "lodash/isEqual";
import isNil from "lodash/isNil";
import xor from "lodash/xor";
const isInvalid = (path) => /(\[|\.)undefined(\]|\.)/.test(path) || /\[-1\]/.test(path);
const defaultOptions = {
    checkExistence: false,
    checkEqual: true
};
export default function (state, path, value, options) {
    const opts = options ? { ...defaultOptions, ...options } : defaultOptions;
    const prev = get(state, path);
    return isInvalid(path) ||
        (opts.checkExistence && isNil(prev)) ||
        (opts.checkEqual &&
            ((isArray(value) && isArray(prev) && isEmpty(xor(prev, value))) || isEqual(prev, value)))
        ? state
        : set(path, value, state);
}
